import i18n from '@/i18n'

export default {
  tractTypeHeaders () {
    return [
      {
        align: 'center',
        sortable: false,
        text: '',
        value: 'status',
        width: '50px'
      },
      {
        sortable: true,
        text: i18n.t('name'),
        value: 'name',
        align: 'left',
        width: '50%'
      },
      {
        sortable: true,
        text: i18n.t('category'),
        value: 'category',
        align: 'center',
        width: '50%'
      },
      {
        sortable: false,
        text: i18n.t('requirements'),
        value: 'requiredFields',
        align: 'center',
        width: '160px'
      },
      {
        sortable: false,
        text: i18n.t('bundles'),
        value: 'templateBundles',
        align: 'center',
        width: '160px'
      },
      {
        sortable: false,
        text: i18n.t('actions'),
        value: 'actions',
        align: 'center',
        width: '120px'
      }
    ]
  }
}
